import { useEffect, useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { IArtEntity } from "../../../Services/api/arts/arts.interface";
import { DestroyArtsUseCase } from "../../../Usecase/Arts/destroy-arts-usecase";
import { ListArtsUseCase } from "../../../Usecase/Arts/list-arts-usecase";
import { ListCustomersUseCase } from "../../../Usecase/Customers/list-customers-usecase";
import { ICustomerEntity } from "../../../Services/api/customers/customers.interface";
import { useNavigate, useParams } from "react-router-dom";
import { ListArtsByCustomerUseCase } from "../../../Usecase/Arts/list-by-cusomter-usecase";
import { ShowCustomersUseCase } from "../../../Usecase/Customers/show-customers-usecase";

interface IUseListArtsByCustomerProps {
  listArtsUseCase: ListArtsUseCase
  destroyArtsUseCase: DestroyArtsUseCase
  listCustomersUseCase: ListCustomersUseCase
  listArtsByCustomerUseCase: ListArtsByCustomerUseCase
  showCustomersUseCase: ShowCustomersUseCase
}
export function useListArtsByCustomer({ listArtsUseCase, destroyArtsUseCase, listCustomersUseCase, listArtsByCustomerUseCase, showCustomersUseCase }: IUseListArtsByCustomerProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<IArtEntity[]>([])
    const [artToDestroy, setArtToDestroy] = useState('')
    const [totalRegisters, setTotalRegisters] = useState(1)
    const [customerSelected, setCustomerSelected] = useState<ICustomerEntity>()

    const [pageCustomer, setPageCustomer] = useState(1)
    const [dataCustomer, setDataCustomer] = useState<ICustomerEntity[]>([])
    const [totalRegistersCustomer, setTotalRegistersCustomer] = useState(1)

    const params = useParams()
   
    const { showToast } =  useToast()
    const navigate = useNavigate()

    // const listArts = async ({ page: currentPage }: any) => {
        
    //     try {
    //       setLoading(true)
          
    //       const listResult = await listArtsUseCase.handle(currentPage);

    //       if (listResult.isFailure) {
       
    //         showToast(String(listResult?.error?.error), 'error');
    //         return;
    //       }

    //      const list = listResult.getValue()

       
    //         setData(list?.data || [])
    //         setTotalRegisters(list?.data?.length || 0)
         

    
    //      setPage(currentPage)
    //     } catch (error) {
    //       console.log("error listArts function: ", error)
    //     } finally {
    //       setLoading(false);
    //     }
    // };

    const loadArts = async ({ page: currentPage, search }: any) => {
        
      try {
        setLoading(true)
        
        const listResult = await listArtsByCustomerUseCase.handle({ page: currentPage, searchBy: search, customerId: String(params.customerId) });

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

        const list = listResult.getValue()

     
        setData(list?.data || [])
        setTotalRegisters(list?.data?.length || 0)
        setPage(currentPage)
      } catch (error) {
        console.log("error loadArts function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const list = useMemo(() => {
        const rows = data?.map(art => {

            return {
                id: art.id,
                name: art?.product?.name,
                photo: art.artLink
            }
        })

        return rows
    }, [data])

    const handleDestroyArt = async () => {
        
      try {
        setLoading(true)
        
        const destroyResult = await destroyArtsUseCase.handle(artToDestroy);

        if (destroyResult.isFailure) {
     
          showToast(String(destroyResult?.error?.error), 'error');
          return;
        }

        setArtToDestroy('')
        showToast('Removido com sucesso.', 'success');

      //  await listArts({ page: 1 });
      } catch (error) {
        console.log("error destroyArts function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const showCustomer  = async (customerId: string) => {
      
      try {
        setLoading(true)
        
        const showResult = await showCustomersUseCase.handle(customerId);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

        const customer = showResult.getValue()

        if(customer?.id){
          setCustomerSelected(customer)
        }

        

      } catch (error) {
        console.log("error listArts function: ", error)
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if(params.customerId){
        showCustomer(String(params.customerId))
      }
    }, [])



      

    return {
        loading,
        list,
        data,
        setArtToDestroy,
        artToDestroy,
        handleDestroyArt,
        totalRegisters,
        loadArts,
        totalRegistersCustomer,
        navigate,
        customerSelected
        
    }
}